import Tag from '@/models/Tag'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1,
    },
    tagDetails: null,
  },

  mutations: {
    setTagList(state, tags) {
      each(tags, (tag) => {
        const exist = find(state.list, { id: tag.id })
        if (!exist) {
          state.list.push(new Tag(tag))
        }
      })
    },

    clearTagList(state) {
      state.list = []
    },

    setTagListMeta(state, meta) {
      state.listMeta = meta
    },

    setTagDetails(state, tag) {
      if (tag instanceof Tag) {
        state.tagDetails = tag
      } else {
        state.tagDetails = new Tag(tag)
      }
    },

    clearTagDetails(state) {
      state.tagDetails = null
    },
  },

  actions: {
    async getTags({ commit }, params) {
      const query = Tag.page(params.page || 1).orderBy(params.sort)
      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query.params({ limit: 20 }).get()
      commit('setTagList', res.data)
      commit('setTagListMeta', res.meta)
    },

    async getTagDetails({ commit }, id) {
      const { data } = await Api.get(`admin/tags/${id}`)
      commit('setTagDetails', data.data)
    },

    async createTag({ commit }, formData) {
      const { data } = await Api.post(`admin/tags`, formData)
      commit('setTagDetails', data.data)
    },

    async updateTag({ commit }, formData) {
      const { data } = await Api.put(`admin/tags/${formData.id}`, formData)
      commit('setTagDetails', data.data)
    },

    async deleteTag({ commit }, id) {
      await Api.delete(`admin/tags/${id}`)
      commit('clearTagDetails', id)
    },

    async exportToExcel({ commit }, params) {
      let endpoint = params.search
        ? `admin/tags/export/${params.search}`
        : `admin/tags/export`
      const file = await Api.get(endpoint, {
        responseType: 'blob',
      })
      return file
    },
  },
}
